/**
 * @fileoverview Dev/stage auth-bypass identity constants shared by every
 * FireSight web client (system-web, tenant-web, mobile-pwa).
 * @module auth/devBypass
 *
 * Responsibilities:
 * - Single source of truth for the sentinel bearer token and synthetic
 *   principal identity web clients use when the non-prod auth bypass is
 *   active (VITE_AUTH_BYPASS=true and appEnv !== 'prod').
 *
 * Dependencies:
 * - None. Pure constants.
 *
 * Architecture:
 * - Consumed as TypeScript source (main/types → src/index.ts), mirroring the
 *   rest of @firesquirrel/web-auth. The API-side counterparts live in
 *   @firesquirrel/core (`api/packages/core/src/devBypass.ts`) — the two
 *   packages must stay in sync because the sentinel token crosses the HTTP
 *   boundary between web clients and APIs.
 *
 * Notes:
 * - These are identifiers, not secrets. APIs only honor the sentinel when
 *   their own non-prod gate (AUTH_BYPASS=true and APP_ENV !== 'prod') is
 *   active; production code paths must never accept it.
 */

/** Opaque bearer-token sentinel sent to the APIs when the dev/stage auth bypass is active. */
export const DEV_BYPASS_TOKEN = 'dev-bypass-token';

/** Canonical ObjectId hex of the synthetic dev/stage system-admin actor (matches @firesquirrel/core). */
export const DEV_BYPASS_ACTOR_ID = '0000000000000000000000a1';

/** Synthetic principal username used by the dev/stage auth bypass. */
export const DEV_BYPASS_USERNAME = 'dev-system-admin';

/** Synthetic principal email used by the dev/stage auth bypass. */
export const DEV_BYPASS_EMAIL = 'dev@firesquirrel.local';

/** Synthetic principal display name used by the dev/stage auth bypass. */
export const DEV_BYPASS_DISPLAY_NAME = 'Dev System Admin';
